import { useState } from 'react';

import { api } from '../api/client.js';
import { Icon } from '../components/Icon.js';
import { useT } from '../i18n/index.js';
import { useMe } from '../state/auth.js';

/** "Confirm your email" / "a parent needs to agree", with a resend button. */
export function AccountBanners() {
  const t = useT();
  const me = useMe();
  const [sent, setSent] = useState(false);
  if (!me || me.active) return null;
  const resend = () => {
    void api
      .resendEmails()
      .then(() => setSent(true))
      .catch(() => undefined);
  };
  return (
    <div className="account-banner" role="status">
      <Icon name="mail" size={18} />
      <div>
        {!me.emailVerified && <p>{t.auth.unverified(me.email)}</p>}
        {me.consent === 'pending' && <p>{t.auth.consentPending(me.parentEmail ?? '')}</p>}
      </div>
      {sent ? (
        <span className="form-ok">{t.auth.resent}</span>
      ) : (
        <button className="btn btn-sm" onClick={resend}>
          {t.auth.resend}
        </button>
      )}
    </div>
  );
}
